"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _reactRouter = require("react-router");
var _hooks = require("../utils/hooks");
function _default(props) {
  var location = (0, _reactRouter.useLocation)();
  (0, _hooks.onChange)(function () {
    document.body.scrollTo(0, 0);
  }, [location.pathname]);
  return props.children;
}